import { TableFilterState } from '@/components/data-table/filters-v2';

import { TIME_OFF_QUERY_KEY_ROOT } from './time-offs-query-keys';

/**
 * Member-scoped time-off query keys. Rooted under
 * `['time-off', 'member', memberId, ...]` so they never collide with the
 * current-user keys (`['time-off', 'balances' | 'requests']`).
 */
const MEMBER_ROOT = (memberId: string) => [TIME_OFF_QUERY_KEY_ROOT, 'member', memberId];

export const getMemberTimeOffBalancesQueryKey = (memberId: string) => [
  ...MEMBER_ROOT(memberId),
  'balances',
];

export const getMemberTimeOffRequestsQueryKey = (memberId: string, filters: TableFilterState) => [
  ...MEMBER_ROOT(memberId),
  'requests',
  filters,
];

export const getMemberTimeOffRequestDetailsQueryKey = (memberId: string, requestId: number) => [
  ...MEMBER_ROOT(memberId),
  'requests',
  'detail',
  requestId,
];

/**
 * Distinct from the personal page's `'time-offs-list'` so column sizing /
 * visibility persisted by `useDataTable` don't collide. A single shared id
 * across members is intentional — managers get one consistent column layout.
 */
export const MEMBER_TIME_OFFS_TABLE_ID = 'member-time-offs-list';

/** Distinct from the personal page's persisted-filters key. */
export const MEMBER_TIME_OFFS_TABLE_FILTERS_STORAGE_KEY = 'member-time-offs-table-filters';
